import { DesktopAccessDisabledRounded } from "@mui/icons-material";

export const holesList = [
  { id: 1, label: "HOLES", isLabel: true },
  { id: 2, label: 1 },
  { id: 3, label: 2 },
  { id: 4, label: 3 },
  { id: 5, label: 4 },
  { id: 6, label: 5 },
  { id: 7, label: 6 },
  { id: 8, label: 7 },
  { id: 9, label: 8 },
  { id: 10, label: 9 },
  { id: 11, label: "OUT", isLabel: true },
  { id: 12, label: 10 },
  { id: 13, label: 11 },
  { id: 14, label: 12 },
  { id: 15, label: 13 },
  { id: 16, label: 14 },
  { id: 17, label: 15 },
  { id: 18, label: 16 },
  { id: 19, label: 17 },
  { id: 20, label: 18 },
  { id: 21, label: "IN", isLabel: true },
  { id: 22, label: "TOTAL", isLabel: true },
];

export const indexList = [
  { id: 1, label: "INDEX", isLabel: true },
  { id: 2, label: 0 },
  { id: 3, label: 0 },
  { id: 4, label: 0 },
  { id: 5, label: 0 },
  { id: 6, label: 0 },
  { id: 7, label: 0 },
  { id: 8, label: 0 },
  { id: 9, label: 0 },
  { id: 10, label: 0 },
  { id: 11, label: "", isLabel: true },
  { id: 12, label: 0 },
  { id: 13, label: 0 },
  { id: 14, label: 0 },
  { id: 15, label: 0 },
  { id: 16, label: 0 },
  { id: 17, label: 0 },
  { id: 18, label: 0 },
  { id: 19, label: 0 },
  { id: 20, label: 0 },
  { id: 21, label: "", isLabel: true },
  { id: 22, label: "", isLabel: true },
];

export const parList = [
  { id: 1, label: "PAR", isLabel: true },
  { id: 2, label: 0 },
  { id: 3, label: 0 },
  { id: 4, label: 0 },
  { id: 5, label: 0 },
  { id: 6, label: 0 },
  { id: 7, label: 0 },
  { id: 8, label: 0 },
  { id: 9, label: 0 },
  { id: 10, label: 0 },
  { id: 11, label: "0", isLabel: true },
  { id: 12, label: 0 },
  { id: 13, label: 0 },
  { id: 14, label: 0 },
  { id: 15, label: 0 },
  { id: 16, label: 0 },
  { id: 17, label: 0 },
  { id: 18, label: 0 },
  { id: 19, label: 0 },
  { id: 20, label: 0 },
  { id: 21, label: "0", isLabel: true },
  { id: 22, label: "0", isLabel: true },
];

export const vsRow = [
  { hole: 1, label: "tie", count: 0 },
  { hole: 2, label: "tie", count: 0 },
  { hole: 3, label: "tie", count: 0 },
  { hole: 4, label: "tie", count: 0 },
  { hole: 5, label: "tie", count: 0 },
  { hole: 6, label: "tie", count: 0 },
  { hole: 7, label: "tie", count: 0 },
  { hole: 8, label: "tie", count: 0 },
  { hole: 9, label: "tie", count: 0 },
  { hole: "empty", label: "", count: 0 },
  { hole: 10, label: "tie", count: 0 },
  { hole: 11, label: "tie", count: 0 },
  { hole: 12, label: "tie", count: 0 },
  { hole: 13, label: "tie", count: 0 },
  { hole: 14, label: "tie", count: 0 },
  { hole: 15, label: "tie", count: 0 },
  { hole: 16, label: "tie", count: 0 },
  { hole: 17, label: "tie", count: 0 },
  { hole: 18, label: "tie", count: 3 },
];

export const showRow1 = [
  { id: 1, score: 0 },
  { id: 2, score: 0 },
  { id: 3, score: 0 },
  { id: 4, score: 0 },
  { id: 5, score: 0 },
  { id: 6, score: 0 },
  { id: 7, score: 0 },
  { id: 8, score: 0 },
  { id: 9, score: 0 },
  { id: "out", score: 0, isLabel: true },
  { id: 10, score: 0 },
  { id: 11, score: 0 },
  { id: 12, score: 0 },
  { id: 13, score: 0 },
  { id: 14, score: 0 },
  { id: 15, score: 0 },
  { id: 16, score: 0 },
  { id: 17, score: 0 },
  { id: 18, score: 0 },
  { id: "in", score: 0, isLabel: true },
  { id: "total", score: 0, isLabel: true },
];

export const showRow2 = [
  { id: 1, score: 0 },
  { id: 2, score: 0 },
  { id: 3, score: 0 },
  { id: 4, score: 0 },
  { id: 5, score: 0 },
  { id: 6, score: 0 },
  { id: 7, score: 0 },
  { id: 8, score: 0 },
  { id: 9, score: 0 },
  { id: "out", score: 0, isLabel: true },
  { id: 10, score: 0 },
  { id: 11, score: 0 },
  { id: 12, score: 0 },
  { id: 13, score: 0 },
  { id: 14, score: 0 },
  { id: 15, score: 0 },
  { id: 16, score: 0 },
  { id: 17, score: 0 },
  { id: 18, score: 0 },
  { id: "in", score: 0, isLabel: true },
  { id: "total", score: 0, isLabel: true },
];

export const courseFields = { name: "Course Name", date: "Date", time: "Time" };
export const playerFields = {
  group1: { name: "", teeColor: "White", handicapValue: "0" },
  group2: { name: "", teeColor: "White", handicapValue: "0" },
};

export const getModifiedCourseLists = (courseObj = []) => {
  let holesList = [];
  let indexList = [];
  let parList = [];

  courseObj.map((course, index) => {
    const x = index + 1;
    if (index < 18) {
      holesList.push({
        id: x,
        label: course.hole_no != undefined ? course.hole_no : x,
      });
      indexList.push({ id: x, label: course.index });
      parList.push({ id: x, label: course.par });
    }
  });

  for (let i = 0; i < holesList.length; i++) {
    if (i == 0) {
      holesList.unshift({ id: "holes", label: "HOLES", isLabel: true });
      indexList.unshift({ id: "index", label: "INDEX", isLabel: true });
      parList.unshift({ id: "par", label: "PAR", isLabel: true });
    }

    if (i == 10) {
      holesList.splice(i, 0, { id: "out", label: "OUT", isLabel: true });
      indexList.splice(i, 0, { id: "out", label: "", isLabel: true });
      parList.splice(i, 0, { id: "out", label: "36", isLabel: true });
    }

    if (i == 17) {
      holesList.push(
        { id: "in", label: "IN", isLabel: true },
        { id: "total", label: "TOTAL", isLabel: true }
      );
      indexList.push(
        { id: "in", label: "", isLabel: true },
        { id: "total", label: "", isLabel: true }
      );
      parList.push(
        { id: "in", label: "36", isLabel: true },
        { id: "total", label: "72", isLabel: true }
      );
    }
  }

  return { holesList, indexList, parList };
};

export const getPlayerWithBenefit = (
  player1Handicap,
  player2Handicap,
  handicapDifferential
) => {
  let gotBenefit;

  let diff = Math.abs(player1Handicap - player2Handicap);
  const matchHandicap = Math.round(diff * handicapDifferential);

  if (player1Handicap > player2Handicap) gotBenefit = "group1";
  else gotBenefit = "group2";

  return { benefitOf: matchHandicap, awardedTo: gotBenefit };
};

export const finMpScore = (obj, playerScore, key) => {
  const newScoreList = obj.map((list) => {
    const found = playerScore[key].find((pl) => pl.id == list.hole_no);
    if (found.id == list.hole_no)
      return { ...list, score: found.score, advantage: found.benefit };
    else return;
  });
  return newScoreList;
};

export const getMiddleRow = (playerScore, runIndex) => {
  let countUp = 0;
  let rowCount = [],
    p = [],
    q = [];
  const { group1, group2 } = playerScore;
  let toFill = false;
  let loopStart;
  let ran = false;
  let shouldRunMore = true;
  let valueSD;

  const filteredScore1 = group1.filter((el) => el.score != "");
  const filteredScore2 = group2.filter((el) => el.score != "");

  const decider =
    filteredScore1.length > filteredScore2.length
      ? filteredScore1.length <= 18 && filteredScore2.length
      : filteredScore2.length <= 18 && filteredScore1.length;

  for (let i = 0; i < decider; i++) {
    if (group1.length > 0 && group2.length > 0 && shouldRunMore) {
      p.push(filteredScore1[i]);
      q.push(filteredScore2[i]);

      if (group1[i].score && group2[i].score) {
        let pl1Score = group1[i].benefit
          ? group1[i].score - 1
          : group1[i].score;
        let pl2Score = group2[i].benefit
          ? group2[i].score - 1
          : group2[i].score;

        if (pl1Score !== "" && pl2Score !== "") {
          if (pl1Score == pl2Score) {
            if (countUp > 0) {
              const { hole, ...rest } = rowCount[rowCount.length - 1];
              rowCount.push({ hole: i, ...rest });
            } else {
              rowCount.push({ hole: i, label: "tie", count: 0 });
            }
          } else if (pl1Score < pl2Score) {
            if (rowCount.length == 0 && countUp == 0) {
              countUp = countUp + 1;
              rowCount.push({ hole: i, label: "group1", count: countUp });
            } else {
              const lastPl = rowCount[rowCount.length - 1].label;
              if (lastPl == "group1") {
                countUp = countUp + 1;
                rowCount.push({ hole: i, label: "group1", count: countUp });
              } else if (lastPl == "group2") {
                if (countUp == 1) {
                  countUp = countUp - 1;
                  rowCount.push({ hole: i, label: "tie", count: 0 });
                } else if (countUp > 1) {
                  countUp = countUp - 1;
                  rowCount.push({ hole: i, label: "group2", count: countUp });
                }
              } else if (lastPl == "tie") {
                countUp = countUp + 1;
                rowCount.push({ hole: i, label: "group1", count: countUp });
              }
            }
          } else if (pl2Score < pl1Score) {
            if (rowCount.length == 0 && countUp == 0) {
              countUp = countUp + 1;
              rowCount.push({ hole: i, label: "group2", count: countUp });
            } else {
              const lastPl = rowCount[rowCount.length - 1].label;
              if (lastPl == "group2") {
                countUp = countUp + 1;
                rowCount.push({ hole: i, label: "group2", count: countUp });
              } else if (lastPl == "group1") {
                if (countUp == 1) {
                  countUp = countUp - 1;
                  rowCount.push({
                    hole: group2.length - 1,
                    label: "tie",
                    count: countUp,
                  });
                } else if (countUp > 1) {
                  countUp = countUp - 1;
                  rowCount.push({
                    hole: group2.length - 1,
                    label: "group1",
                    count: countUp,
                  });
                }
              } else if (lastPl == "tie") {
                countUp = countUp + 1;
                rowCount.push({ hole: i, label: "group2", count: countUp });
              }
            }
          }
        }
      }
    }

    if (countUp >= 18 - i && 18 - i != 1) {
      loopStart = 18 - i;
      toFill = true;
      ran = true;
      shouldRunMore = false;
    }
  }

  rowCount.splice(9, 0, { hole: "label", label: "", count: 0 });

  if (!shouldRunMore) {
    valueSD = `${countUp}&${18 - (rowCount.length - 1)}`;
    rowCount.splice(rowCount.length - 1, 1, {
      ...rowCount[rowCount.length - 1],
      count: `${countUp}&${18 - (rowCount.length - 1)}`,
    });
  }

  if (decider == 18) {
    toFill = false;
    shouldRunMore = true;
  }

  return {
    rowCount,
    countUp,
    toFill,
    loopStart,
    valueSD,
    newLoopStarter: rowCount.length - 1,
  };
};

export const getAdjustedScore = (scoreList, parList) => {
  let adjScore = 0;
  const filteredParList = parList.filter((par) => typeof par.id != "string");

  for (let i = 0; i < 18; i++) {
    const targetPar = +filteredParList[i].label + 3;
    // const sc = scoreList[i].benefit
    //   ? +scoreList[i].score - 1
    //   : +scoreList[i].score;

    if (scoreList[i].score >= targetPar)
      adjScore += filteredParList[i].label + 2;
    // if (sc >= targetPar) adjScore += filteredParList[i].label + 2;
    else adjScore += +scoreList[i].score;
  }

  return adjScore;
};

export const getFinalPayloadData = (
  playerScore,
  courseParIndexSelector,
  scoreUpCount,
  modifiedIndexParList
) => {
  const group1Scores = finMpScore(
    courseParIndexSelector.status.index_par.slice(0, 18),
    playerScore,
    "group1"
  );
  const group2Scores = finMpScore(
    courseParIndexSelector.status.index_par.slice(0, 18),
    playerScore,
    "group2"
  );
  const scoreUplabel = scoreUpCount[scoreUpCount.length - 1].label;

  const adjScore1 = getAdjustedScore(
    playerScore.group1,
    modifiedIndexParList.parList
  );
  const adjScore2 = getAdjustedScore(
    playerScore.group2,
    modifiedIndexParList.parList
  );

  return {
    group1Scores,
    group2Scores,
    scoreUplabel,
    adjScore1,
    adjScore2,
  };
};

const scoreCalc = (score) => {
  return score.reduce((acc, val) => acc + val.score, 0);
};

export const getScores = (list) => {
  let score = [];

  for (let i = 0; i < list.length; i++) {
    if (list[i].score == list[i].par + 1) {
      score.push({
        id: i + 1,
        score: list[i].score,
        label: "#0000FF",
        benefit: list[i].advantage,
      });
    } else if (list[i].score == list[i].par - 1) {
      score.push({
        id: i + 1,
        score: list[i].score,
        label: "#FF0000",
        benefit: list[i].advantage,
      });
    } else if (list[i].score == list[i].par - 2) {
      score.push({
        id: i + 1,
        score: list[i].score,
        label: "#FFC700",
        benefit: list[i].advantage,
      });
    } else if (list[i].score >= list[i].par + 2) {
      score.push({
        id: i + 1,
        score: list[i].score,
        label: "#000000",
        benefit: list[i].advantage,
      });
    } else {
      score.push({
        id: i + 1,
        score: list[i].score,
        label: "transparent",
        benefit: list[i].advantage,
      });
    }
  }

  const outCalc = scoreCalc(score.slice(0, 9));
  const inCalc = scoreCalc(score.slice(9, 19));

  score.splice(9, 0, { id: "out", score: outCalc, isLabel: true });

  score.splice(19, 0, { id: "in", score: inCalc, isLabel: true });

  score.splice(20, 0, { id: "total", score: outCalc + inCalc, isLabel: true });

  return score;
};

export const generatePlayersMockData = () => {
  let score1List = [],
    score2List = [];

  for (let i = 0; i < 2; i++) {
    for (let j = 0; j < 18; j++) {
      if (i == 0) score1List.push({ id: j + 1, score: "", benefit: false });
      if (i == 1) score2List.push({ id: j + 1, score: "", benefit: false });
    }
  }

  return { score1List, score2List };
};

export const autoScoreFiller = (
  loopStart,
  totalHoles,
  playerNo,
  benefit,
  handlePlayerScore,
  benefitOn,
  courseParIndexSelector,
  playerHandicap
) => {
  for (let i = loopStart; i < totalHoles; i++) {
    const ben = benefitOn[i] != null ? benefitOn[i].hasBenefit : false;
    const indexScore =
      courseParIndexSelector?.status?.index_par[i]?.index <= playerHandicap;

    if (benefit == playerNo) {
      const newScore = {
        id: i + 1,
        score:
          ben || indexScore
            ? courseParIndexSelector?.status?.index_par[i].par + 1
            : courseParIndexSelector?.status?.index_par[i].par,
        benefit: ben,
      };

      handlePlayerScore(
        newScore.score,
        newScore.id,
        playerNo,
        newScore.benefit
      );
    } else {
      const newScore = {
        id: i + 1,
        score: indexScore
          ? courseParIndexSelector?.status?.index_par[i].par + 1
          : courseParIndexSelector?.status?.index_par[i].par,
        benefit: false,
      };

      handlePlayerScore(newScore.score, newScore.id, playerNo, false);
    }
  }
};

export const fillScoreForEdit = (scoreList) => {
  let temp = [];

  for (let i = 0; i < scoreList.length; i++) {
    temp.push({ id: i + 1, score: scoreList[i].score || "" });
  }

  return temp;
};

export const reImplementBenefitOn = (
  teeInfo,
  courseParIndexSelector,
  startLoop,
  benefitOn
) => {
  let temp = [];
  temp.push(...benefitOn.slice(0, startLoop));
  const playerWithBenefit = getPlayerWithBenefit(
    teeInfo.group1.handicap_value,
    teeInfo.group2.handicap_value,
    1
  );
  for (let i = startLoop + 1; i <= 18; i++) {
    if (
      courseParIndexSelector.status.index_par[i - 1].index <=
      playerWithBenefit.benefitOf
    ) {
      temp.push({ benefittedIndex: i, hasBenefit: true });
    } else {
      temp.push({ benefittedIndex: i, hasBenefit: false });
    }
  }
  benefitOn.length = 0;
  benefitOn.splice(0, benefitOn.length, ...temp);

  return { awardedTo: playerWithBenefit.awardedTo, benefitArr: benefitOn };
};

export const getTrack = (statusTrack) => {
  let newStatusTrack = [];
  for (let i = 0; i < statusTrack.length; i++)
    newStatusTrack.push(statusTrack[i]);

  newStatusTrack.splice(9, 0, { hole: "label", label: "", count: 0 });
  return newStatusTrack;
};
